import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { OrganisationResolverComponent } from './shared/components/organisation-resolver/organisation-resolver.component';
import { AppRouteGuard } from './app.route.guard';
import { environment } from 'environments/environment';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/dashboard' (AppRouteGuard handles this redirect when the /#/ fragment is empty or invalid)
    { path: '', canActivate: [AppRouteGuard], pathMatch: 'full', children: [] }, //... redirectTo: 'dashboard' },

    // Redirect signed in user to the '/dashboard'
    //
    // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'dashboard' },

    // Available to authenticated AND unauthenticated users in different situations...
    {
        path: '',
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: 'form-vault', title: 'Form Vault', loadChildren: (): Promise<any> => import('app/modules/form-vault/form-vault.routes'), canMatch: [() => environment.options.formVault.enabled] },
            { path: 'form', loadChildren: (): Promise<any> => import('app/modules/forms/form.routes') },
            { path: 'error', title: 'Error', loadChildren: (): Promise<any> => import('app/modules/error/error.routes') },
            { path: 'workflow-action', title: 'Workflow Action', loadChildren: (): Promise<any> => import('app/modules/workflow-action/workflow-action.routes') },
            { path: 'documents/:documentName', loadComponent: (): Promise<any> => import('app/modules/pages/documents/documents.component').then(m => m.DocumentsComponent) },
        ]
    },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'confirmation-required', title: 'Confirmation Required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes') },
            { path: 'forgot-password', title: 'Forgot Password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes') },
            { path: 'expired-password', data: { title: 'Expired Password!' }, loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes') },
            { path: 'reset-password', title: 'Reset Password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes') },
            { path: 'sign-in', title: 'Sign In', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') },
            { path: 'sign-in-error', title: 'Sign Up', loadChildren: () => import('app/modules/auth/sign-in-error/sign-in-error.routes') },
            { path: 'sign-up', title: 'Sign Up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes'), canMatch: [() => environment.security.allowSelfRegistration] }
        ]
    },

    // Auth routes for authenticated users (Empty Layout override)
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-out', title: 'Sign Out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
            { path: 'unlock-session', title: 'Unlock Session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes') }
        ]
    },

    // Routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: 'dashboard', title: 'Dashboard', loadChildren: (): Promise<any> => import('app/modules/dashboard/dashboard.routes') },
            { path: 'account', children: [
                { path: 'profile', title: 'My Profile', loadChildren: (): Promise<any> => import('app/modules/pages/profile/profile.routing') }
            ] },

            // 404 & Catch all
            // { path: '404-not-found', pathMatch: 'full', loadChildren: (): Promise<any> => import('app/modules/error/error-404/error-404.routes') },
            { path: '**', redirectTo: 'error/404' }
        ]
    },

    { path: ':organisationSlug', canActivate: [AppRouteGuard], component: OrganisationResolverComponent },
    { path: ':organisationSlug/*', canActivate: [AppRouteGuard], component: OrganisationResolverComponent },
    { path: '**', canActivate: [AppRouteGuard], component: OrganisationResolverComponent },

];
